/**
 * Created by Bart Decorte
 * Date: 2019-07-17
 * Time: 10:54
 */
import Column from "./Column";

class IdColumn extends Column {

  constructor(params) {
    super(params);
    this.init();
  }

}

export default IdColumn;


// WEBPACK FOOTER //
// ./resources/assets/js/columns/IdColumn.js